import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVisualGraph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path fillRule="evenodd" d="M14.8 10.75h-6v-1.5h6z" clipRule="evenodd" />
    <path
      fillRule="evenodd"
      d="M9.45 9.605c-.718.697-1.67 1.217-2.907.967l.275-1.423c.523.105.982-.065 1.51-.577.53-.514 1.007-1.257 1.55-2.103l.07-.107c.545-.848 1.162-1.795 1.924-2.468.791-.7 1.81-1.164 3.11-.906l-.269 1.425c-.666-.132-1.21.067-1.768.56-.588.52-1.106 1.295-1.671 2.174q-.053.08-.104.162c-.51.794-1.068 1.664-1.72 2.296"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.022 16.105c.72.697 1.67 1.217 2.908.967l-.274-1.423c-.524.105-.983-.065-1.511-.577-.53-.514-1.007-1.257-1.55-2.103l-.07-.107c-.545-.848-1.162-1.795-1.924-2.468-.791-.7-1.81-1.164-3.11-.906l.269 1.425c.666-.132 1.21.067 1.768.56.588.52 1.106 1.295 1.672 2.174l.103.162c.51.794 1.068 1.664 1.72 2.296Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M16.1 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0M4.226 8.724a1.276 1.276 0 1 0 0 2.553 1.276 1.276 0 0 0 0-2.553M1.45 10.001a2.776 2.776 0 1 1 5.553 0 2.776 2.776 0 0 1-5.553 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVisualGraph;
